'use strict';

var useEmailValidation$1 = require('../../../../../../../../_virtual/useEmailValidation.cjs');
var React = require('react');
require('./emailValidation.cjs');
var emailValidation$1 = require('../../../../../../../../_virtual/emailValidation.cjs');

var react = React;
var emailValidation = emailValidation$1.__exports;

/**
 * A hook used to run various validations against emails.
 * It ensures that the email contains an "@" symbol as well as a "."
 */ const useEmailValidation = (options)=>{
    const { isDirty, required, value } = options;
    const validationError = react.useMemo(()=>{
        if (!isDirty || !required && !emailValidation.isEmailPresent(value)) return "";
        if (!emailValidation.isEmailPresent(value)) return "Email is required";
        if (!emailValidation.isEmailAtValid(value)) return 'Email must include "@"';
        if (!emailValidation.isEmailDotValid(value)) return 'Email must include "."';
        if (!emailValidation.isEmailRegexValid(value)) return "Email is invalid";
        return "";
    }, [
        isDirty,
        required,
        value
    ]);
    return {
        validationError
    };
};

useEmailValidation$1.__exports.useEmailValidation = useEmailValidation;

module.exports = useEmailValidation$1.__exports;
//# sourceMappingURL=useEmailValidation.cjs.map
